import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-private-program w-full max-md:bg-transparent',
    container:
      'relative container flex h-[560px] overflow-hidden max-md:relative max-md:h-auto max-md:flex-col',
    title: 'sr-only',
    content:
      'max-xs:w-auto max-xs:-mt-[78px] relative my-auto w-[700px] max-lg:w-[480px] max-md:-mt-[105px]',
    logo: 'max-xs:h-[32px] h-[48px] w-auto',
    firstTitle:
      'max-xs:text-[54px] max-xs:-mt-2 max-xs:-ml-1 -mt-5 -ml-2 text-[96px] leading-[120%] font-semibold uppercase max-lg:-mt-3 max-lg:text-[68px]',
    secondTitle:
      'font-cormorant-garamond text-yellow-naos max-xs:text-[72px] max-xs:w-[344px] max-xs:-mt-6 -mt-10 w-[630px] text-right text-[132px] leading-[110%] font-bold tracking-[-1.3px] italic max-lg:-mt-8 max-lg:w-[440px] max-lg:text-[96px]',
    description:
      'max-xs:heading-m max-xs:mt-4 mt-5 pr-5 text-[20px] leading-[180%] font-light',
    mobileWrapper:
      'max-md:bg-private-program max-md:relative max-md:-mx-4 max-md:h-[296px] max-md:w-[calc(100%+32px)] max-md:overflow-hidden',
    imageContainer:
      'max-xs:-right-20 absolute -top-5 right-0 aspect-[737/625] w-[737px] -scale-x-100 max-xl:right-auto max-xl:left-[480px] max-lg:top-0 max-lg:left-[300px] max-lg:w-[690px] max-md:-top-7 max-md:right-0 max-md:left-auto max-md:w-[420px] max-sm:-right-8',
    image: 'object-cover',
    button: 'max-xs:w-full max-xs:mt-8 mt-10'
  }
});
